import { useEffect } from 'react';
import { useSEOContext } from './SEOProvider';
import { SEOConfig } from '../../types';

export function useSEO(config: SEOConfig) {
    const { updateSEO } = useSEOContext();

    useEffect(() => {
        updateSEO(config);
    }, [config, updateSEO]);
}

// Hook para generar meta tags en SSR/SSG
export function generateMetaTags(config: SEOConfig): string {
    const tags: string[] = [];

    // Title
    if (config.title) {
        tags.push(`<title>${escapeHtml(config.title)}</title>`);
    }

    // Meta description
    if (config.description) {
        tags.push(`<meta name="description" content="${escapeHtml(config.description)}">`);
    }

    // Open Graph tags
    if (config.ogTitle || config.title) {
        tags.push(`<meta property="og:title" content="${escapeHtml(config.ogTitle || config.title!)}">`);
    }

    if (config.ogDescription || config.description) {
        tags.push(`<meta property="og:description" content="${escapeHtml(config.ogDescription || config.description!)}">`);
    }

    if (config.ogImage) {
        tags.push(`<meta property="og:image" content="${escapeHtml(config.ogImage)}">`);
    }

    // Twitter Card tags
    const twitterCard = config.twitterCard || 'summary_large_image';
    tags.push(`<meta name="twitter:card" content="${escapeHtml(twitterCard)}">`);

    if (config.ogTitle || config.title) {
        tags.push(`<meta name="twitter:title" content="${escapeHtml(config.ogTitle || config.title!)}">`);
    }

    if (config.ogDescription || config.description) {
        tags.push(`<meta name="twitter:description" content="${escapeHtml(config.ogDescription || config.description!)}">`);
    }

    if (config.ogImage) {
        tags.push(`<meta name="twitter:image" content="${escapeHtml(config.ogImage)}">`);
    }

    // Keywords
    if (config.keywords && config.keywords.length > 0) {
        tags.push(`<meta name="keywords" content="${escapeHtml(config.keywords.join(', '))}">`);
    }

    // Canonical URL
    if (config.canonical) {
        tags.push(`<link rel="canonical" href="${escapeHtml(config.canonical)}">`);
    }

    return tags.join('\n');
}

function escapeHtml(text: string): string {
    const map: { [key: string]: string } = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, (m) => map[m]);
}
